module.exports = __webpack_public_path__ + "static/media/logo-precidia-rentals-white.a4eece9f.svg";